import baseApi from '../../base.api'
import { actions as assignmentActions } from '../../../reducers/assignment.reducer'
import { ASSIGNMENT_PROCESSING_STATUSES } from '../../../../constants/assignment-processing-statuses'
import { cloneDeep } from 'lodash'

export const onUpdateAssignmentLmsConfigStarted = async (
    { courseId, quizId, enabled },
    { dispatch, queryFulfilled, getState },
) => {
    try {
        await queryFulfilled
        const assignment = cloneDeep(getState().assignment.assignment)
        assignment.lms_course_id = courseId
        assignment.lms_quiz_id = quizId
        assignment.lms_enabled = enabled
        dispatch(assignmentActions.setAssignment(assignment))
    } catch (error) {
        console.error('Failed to update assignment query data', error)
    }
}

export const onCreateOrganizationLmsConfigQueryStarted = async (
    { organizationId, lmsUrl, token },
    { dispatch, queryFulfilled },
) => {
    try {
        await queryFulfilled
        dispatch(
            baseApi.util.updateQueryData('fetchLmsConfigs', undefined, draft => {
                draft.push({ organizationId, lmsUrl, token })
            }),
        )
    } catch (error) {
        console.error('Failed to update fetchLmsConfigs query data', error)
    }
}

export const onImportLmsSubmissionsQueryStarted = async (_, { dispatch, queryFulfilled, getState }) => {
    try {
        await queryFulfilled
        const assignment = cloneDeep(getState().assignment.assignment)
        assignment.lms_submissions_imported = false
        assignment.current_version.processing_msg = 'Importing submissions'
        assignment.current_version.processing_progress = 0
        assignment.current_version.processing_status = ASSIGNMENT_PROCESSING_STATUSES.ADDING_FILES
        dispatch(assignmentActions.setAssignment(assignment))
    } catch (error) {
        console.error('Failed to update assignment query data', error)
    }
}

export const onExportLmsSubmissionsQueryStarted = async (
    { assignmentToken: token, versionId: versionId },
    { dispatch, queryFulfilled, getState },
) => {
    try {
        await queryFulfilled
        const assignment = cloneDeep(getState().assignment.assignment)
        assignment.lms_grades_sent = false
        assignment.current_version.processing_msg = 'Exporting submissions'
        assignment.current_version.processing_progress = 0
        assignment.current_version.processing_status = ASSIGNMENT_PROCESSING_STATUSES.ADDING_FILES
        dispatch(assignmentActions.setAssignment(assignment))

        dispatch(
            baseApi.util.updateQueryData(
                'fetchProgress',
                {
                    token: token,
                    versionId: versionId,
                },
                draft => {
                    draft.exportToLms = true
                },
            ),
        )
    } catch (error) {
        console.error('Failed to update assignment query data', error)
    }
}
